import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import React, { useContext, useRef } from 'react';
import { ModelContext } from './contexts.ts';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Badge } from 'primereact/badge';
import { Toast } from 'primereact/toast';
import HelpMenu from './HelpMenu.tsx';
import ExportButton from './ExportButton.tsx';
import SettingsMenu from './SettingsMenu.tsx';
import MultimaterialColorsDialog from './MultimaterialColorsDialog.tsx';
import ShareButton from './ShareButton.tsx';
export default function Footer({ style }) {
    const model = useContext(ModelContext);
    if (!model)
        throw new Error('No model');
    const state = model.state;
    const toast = useRef(null);
    const severityByMarkerSeverity = new Map([
        [monaco.MarkerSeverity.Error, 'danger'],
        [monaco.MarkerSeverity.Warning, 'warning'],
        [monaco.MarkerSeverity.Info, 'info'],
    ]);
    const markers = state.lastCheckerRun?.markers ?? [];
    const getBadge = (s) => {
        const count = markers.filter(m => m.severity == s).length;
        const sev = s == monaco.MarkerSeverity.Error ? 'danger'
            : s == monaco.MarkerSeverity.Warning ? 'warning'
                : s == monaco.MarkerSeverity.Info ? 'info'
                    : 'success';
        return _jsx(_Fragment, { children: count > 0 && _jsx(Badge, { value: count, severity: severityByMarkerSeverity.get(s) }) });
    };
    const maxMarkerSeverity = markers.length == 0 ? undefined : markers.map(m => m.severity).reduce((a, b) => Math.max(a, b));
    return _jsxs(_Fragment, { children: [_jsx(ProgressBar, { mode: "indeterminate", style: {
                    marginLeft: '5px',
                    marginRight: '5px',
                    visibility: state.rendering || state.previewing || state.checkingSyntax || state.exporting
                        ? 'visible' : 'hidden',
                    height: '6px'
                } }), _jsxs("div", { className: "flex flex-row gap-1", style: {
                    alignItems: 'center',
                    margin: '5px',
                    ...(style ?? {})
                }, children: [state.output && !state.output.isPreview
                        ? (_jsx(ExportButton, {})) : state.previewing ? (_jsx(Button, { icon: "pi pi-bolt", disabled: true, className: "p-button-sm", label: "Previewing..." })) : state.output && state.output.isPreview ? (_jsx(Button, { icon: "pi pi-bolt", onClick: () => model.render({ isPreview: false, now: true }), className: "p-button-sm", disabled: state.rendering, label: state.rendering ? 'Rendering...' : 'Render' })) : undefined, _jsx(ShareButton, {}), _jsx(MultimaterialColorsDialog, {}), (state.lastCheckerRun || state.output) &&
                        _jsxs(Button, { type: "button", severity: maxMarkerSeverity && severityByMarkerSeverity.get(maxMarkerSeverity), icon: "pi pi-align-left", text: !state.view.logs, onClick: () => model.logsVisible = !state.view.logs, className: maxMarkerSeverity && `p-button-${severityByMarkerSeverity.get(maxMarkerSeverity) ?? 'success'}`, children: [getBadge(monaco.MarkerSeverity.Error), getBadge(monaco.MarkerSeverity.Warning), getBadge(monaco.MarkerSeverity.Info)] }), _jsx("div", { style: { flex: 1 } }), _jsx(SettingsMenu, {}), _jsx(HelpMenu, { style: {
                            position: 'absolute',
                            right: 0,
                            top: '4px',
                        } }), _jsx(Toast, { ref: toast })] })] });
}
